module.exports = __webpack_public_path__ + "static/media/intro.153c343d.mp3";